
<div class="shopSearchForm">
  <div id="fixedContainer" class="shopSearchForm__spFixedContainer spOnly">
    <div class="shopSearchForm__spFixedContent">
      <div class="shopSearchForm__spFixedAreaContent">
        <i class="search icon"></i>
        <span>{{ areaLabel(form.model.area, this.areas) }}</span>
      </div>
      <div class="shopSearchForm__spFixedFormOpenButton">
        <button class="ui button" @click="showSearchForm()">変更</button>
      </div>
    </div>
  </div>
  <div class="shopSearchForm__formContainer" id="searchForm">
    <form class="ui form" @submit.prevent="search()">
      <div class="shopSearchForm__header spOnly">
        <span>検索条件</span>
        <button class="ui button" @click.prevent="hideSearchForm()">閉じる</button>
      </div>
      <div class="shopSearchForm__freeTextContainer">
        <label class="shopSearchForm__label">フリーワード</label>
        <div class="shopSearchForm__inputContainer">
          <input type="text" v-model="form.model.q" placeholder="フリーワードで検索">
        </div>
      </div>

      <div class="shopSearchForm__areaContainer">
        <label class="shopSearchForm__label">都道府県・エリア</label>
        <div class="shopSearchForm__inputContainer">
          <dropdown class="shopSearchForm__areaDropdown" v-model="form.model.prefecture"  @change="onPrefectureChange()" :placeholder="'都道府県'">
            <option value=""></option>
            <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
          </dropdown>

          <div class="pcOnly">
          　<label class="shopSearchForm__areaDropdownLabel">エリア</label>
            <dropdown class="shopSearchForm__areaDropdown" v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア'">
              <option value="">エリア</option>
              <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
            </dropdown>

            <label class="shopSearchForm__areaDropdownLabel">エリア詳細</label>
            <dropdown class="shopSearchForm__areaDropdown" ref="areaDetail" v-model="form.model.area_details" @change="onAreaDetailChange()" :placeholder="'指定しない'" :max-size="-1"></dropdown>

              <label class="shopSearchForm__areaDropdownLabel">駅</label>
              <dropdown class="shopSearchForm__areaDropdown" ref="station" v-model="form.model.stations" :placeholder="'指定しない'" :max-size="-1"></dropdown>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__areaAccordionContainer spOnly">
        <div class="title" @click="toggleAreaAccordion('area')" :class="{ 'active': openedAccordions['area'] }">
          <span>エリア選択</span>
          <i class="dropdown icon"></i>
        </div>
        <div class="content" :class="{ 'active': openedAccordions['area'] }">
          <div v-if="area.value !== ''" class="shopSearchForm__areaAccordionContainer__area"
               v-for="area in areaOptions" :key="area.label">
            <div class="flex-container">
              <input type="radio" name="areaGroup" :value="area.value" @change="onAreaChange()" v-model="form.model.area">
              <div class="title" @click="clickArea(area.value)" :class="{ 'active': openedAccordions[area.value] }">
                <span>{{ area.label }}</span>
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div class="content" :class="{ 'active': openedAccordions[area.value] }">
              <div class="ui checkbox" v-for="detail in areaDetailOptions[area.value]" :key="detail.value">
                <input type="checkbox" :id="`detail-${detail.value}`" :value="detail.value" v-model="form.model.area_details" @click="onAreaDetailClick(area.value)" @change="onAccordionAreaDetailChange()">
                <label :for="`detail-${detail.value}`">{{ detail.label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__stationAccordionContainer spOnly">
        <div class="title" @click="toggleAreaAccordion('station')" :class="{ 'active': openedAccordions['station'] }">
          <span>駅選択</span>
          <i class="dropdown icon"></i>
        </div>
        <div class="content" :class="{ 'active': openedAccordions['station'] }">
          <div class="ui checkbox" v-for="station in stationOptions" :key="station.value">
              <input type="checkbox" :id="`station-${station.value}`" :value="station.value" v-model="form.model.stations">
              <label :for="`station-${station.value}`">{{ station.label }}</label>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__shopTypeContainer">
        <label class="shopSearchForm__label">会場の種類</label>
        <div class="shopSearchForm__inputContainer">
          <div v-for="shopType in consts.SHOP_TYPE" :key="shopType.value" class="ui checkbox">
            <input type="checkbox" :id="`shop-type-${shopType.value}`" :value="shopType.value" v-model="form.model.shop_types">
            <label :for="`shop-type-${shopType.value}`">{{ shopType.label }}</label>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__peopleContainer">
        <label class="shopSearchForm__label">人数</label>
        <div class="shopSearchForm__inputContainer">
          <div class="shopSearchForm__peopleDropdownContainer">
            <dropdown class="shopSearchForm__peopleMinDropdown" v-model="form.model.people_from" :options="consts.SHOP_PEOPLE" :placeholder="'人数下限'">
              <option value="">下限なし</option>
            </dropdown>
            <span class="shopSearchForm__peopleBetweenText">〜</span>
            <dropdown class="shopSearchForm__peopleMaxDropdown" v-model="form.model.people_to" :options="consts.SHOP_PEOPLE" :placeholder="'上限なし'">
              <option value="">上限なし</option>
            </dropdown>
          </div>
          <div class="shopSearchForm__seatCondition">
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.people_type" name="people_type" value="1">
              <label>着席</label>
            </div>
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.people_type" name="people_type" value="2">
              <label>立席</label>
            </div>
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.people_type" name="people_type" value="">
              <label>こだわらない</label>
            </div>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__budgetContainer">
        <label class="shopSearchForm__label">予算</label>
        <div class="shopSearchForm__inputContainer">
          <div class="shopSearchForm__budgetDropdownContainer">
            <dropdown class="shopSearchForm__budgetMinDropdown" v-model="form.model.price_from" :placeholder="'下限なし'">
              <option value="">下限なし</option>
              <option value="3000">3,000円</option>
              <option value="4000">4,000円</option>
              <option value="5000">5,000円</option>
              <option value="6000">6,000円</option>
              <option value="7000">7,000円</option>
              <option value="8000">8,000円</option>
              <option value="9000">9,000円</option>
              <option value="10000">10,000円</option>
            </dropdown>
            <span class="shopSearchForm__budgetBetweenText">〜</span>
            <dropdown class="shopSearchForm__budgetMaxDropdown" v-model="form.model.price_to" :placeholder="'上限なし'">
              <option value="">上限なし</option>
              <option value="3000">3,000円</option>
              <option value="4000">4,000円</option>
              <option value="5000">5,000円</option>
              <option value="6000">6,000円</option>
              <option value="7000">7,000円</option>
              <option value="8000">8,000円</option>
              <option value="9000">9,000円</option>
              <option value="10000">10,000円</option>
            </dropdown>
          </div>
          <div class="shopSearchForm__budgetOptionContainer">
            <div class="shopSearchForm__budgetOptionItem">
              <div class="ui checkbox">
                <input type="checkbox" v-model="form.model.drink_flg" value="true">
                <label>飲み放題込み</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__genreContainer">
        <label class="shopSearchForm__label">料理ジャンル</label>
        <div class="shopSearchForm__inputContainer">
          <div v-for="genre in consts.SHOP_GENRE" :key="genre.value" class="ui checkbox">
            <input type="checkbox" :id="`genre-${genre.value}`" :value="genre.value" v-model="form.model.genres">
            <label :for="`genre-${genre.value}`">{{ genre.label }}</label>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__smokingContainer">
        <label class="shopSearchForm__label">喫煙</label>
        <div class="shopSearchForm__inputContainer">
          <div v-for="smoking_type in consts.SMOKING" :key="smoking_type.value" class="ui checkbox radio">
            <input type="radio" v-model="form.model.smoking_type" name="smoking_type" :value=smoking_type.value>
            <label>{{ smoking_type.label }}</label>
          </div>
          <div class="ui checkbox radio">
            <input type="radio" v-model="form.model.smoking_type" name="smoking_type" :value="''">
            <label>指定しない</label>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__featureContainer ui accordion">
        <div class="title">
          <label class="shopSearchForm__featureLabel">こだわり<i class="dropdown icon"></i></label>
        </div>
        <div class="shopSearchForm__inputContainer content">
          <div class="shopSearchForm__featureList">
            <label class="shopSearchForm__featureListLabel">部屋</label>
            <div v-for="feature in consts.SHOP_FEATURES.slice(0, 4)" :key="feature" class="ui checkbox">
              <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
              <label :for="`feature-${feature}`">{{ feature }}</label>
            </div>
          </div>
          <div class="shopSearchForm__featureList">
            <label class="shopSearchForm__featureListLabel">席タイプ</label>
            <div v-for="feature in consts.SHOP_FEATURES.slice(4, 9)" :key="feature" class="ui checkbox">
              <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
              <label :for="`feature-${feature}`">{{ feature }}</label>
            </div>
          </div>
          <div class="shopSearchForm__featureList">
            <label class="shopSearchForm__featureListLabel">設備</label>
            <div v-for="feature in consts.SHOP_FEATURES.slice(9, 17)" :key="feature" class="ui checkbox">
              <input type="checkbox" :id="`feature-${feature}`" :value="feature" v-model="form.model.features">
              <label :for="`feature-${feature}`">{{ feature }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="shopSearchForm__submitButtonContainer">
        <div class="shopSearchForm__inputContainer">
          <div class="shopSearchForm__submitButtonList">
            <button class="ui gray button shopSearchForm__submitClearButton" @click.prevent="clear">クリア</button>
            <button class="ui orange button shopSearchForm__submitSearchButton" :class="{'disabled loading': form.waiting && shops.length === 0}">検索する</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
